// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactModal from "react-modal";
import * as PnMCallbackConfirmationCmp$PorterinFeature from "./PnMCallbackConfirmationCmp.mjs";
import * as PnMCallbackConfirmationModalModuleScss from "../styles/PnMCallbackConfirmationModal.module.scss";

var styles = PnMCallbackConfirmationModalModuleScss;

function PnMCallbackConfirmationModalCmp(Props) {
  var modal_state = Props.modal_state;
  var close_modal = Props.close_modal;
  return React.createElement(ReactModal, {
              isOpen: modal_state,
              onRequestClose: close_modal,
              closeTimeoutMS: 0,
              overlayClassName: styles.overlay,
              className: "" + styles["modal-container"] + "",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement(PnMCallbackConfirmationCmp$PorterinFeature.make, {
                    close_modal: close_modal
                  })
            });
}

var make = PnMCallbackConfirmationModalCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
